import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA8u70Qor13906VFLGLeU1A-B7z4GlbNb0",
  authDomain: "clone-f0339.firebaseapp.com",
  databaseURL: "https://clone-f0339.firebaseio.com",
  projectId: "clone-f0339",
  storageBucket: "clone-f0339.appspot.com",
  messagingSenderId: "19702722778",
  appId: "1:19702722778:web:210d29ffb104883a7135e3",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
